// client/src/hooks/useScopeAutoRefresh.js
// A small hook to auto-refresh page data when academic year or phase changes
// Usage: useScopeAutoRefresh([reloadFn1, reloadFn2])
import { useEffect, useRef } from 'react';

export default function useScopeAutoRefresh(loaders = [], deps) {
  const ayRef = useRef(null);
  const phaseRef = useRef(null);
  const loadersRef = useRef([]);

  useEffect(() => {
    const normalized = Array.isArray(loaders)
      ? loaders
      : (typeof loaders === 'function' ? [loaders] : []);
    loadersRef.current = normalized;
  }, Array.isArray(deps) ? deps : [loaders]);

  useEffect(() => {
    const callLoaders = () => {
      const list = loadersRef.current;
      if (!Array.isArray(list)) return;
      for (const fn of list) {
        if (typeof fn === 'function') {
          try { fn(); } catch (e) { /* ignore */ }
        }
      }
    };

    const onYear = (e) => {
      const newId = e?.detail?.id ?? null;
      if (newId && newId === ayRef.current) return;
      ayRef.current = newId;
      callLoaders();
    };

    const onPhase = (e) => {
      const newCode = e?.detail?.code ?? null;
      if (newCode && newCode === phaseRef.current) return;
      phaseRef.current = newCode;
      callLoaders();
    };

    window.addEventListener('app:ay:changed', onYear);
    window.addEventListener('app:phase:changed', onPhase);
    return () => {
      window.removeEventListener('app:ay:changed', onYear);
      window.removeEventListener('app:phase:changed', onPhase);
    };
  }, []);
}